<template>
    <UsersList
            :users="users"
            :search="search"
            :headers="headers"
    ></UsersList>
</template>

<script>
    import UsersList from "../components/UsersList";
    import axios from 'axios'

    export default {
        name: "ClientUsersList",
        components: {UsersList},
        data() {
            return {
                users: [],
                search: '',
                headers: [
                    {text: 'Name', value: 'username'},
                    {text: 'Email', value: 'email'},
                    {text: 'Role', value: 'role'},
                ],
            }
        },
        mounted() {
            axios.get('/users').then(resp => {
                this.users = resp.data.users
            })
        }
    }
</script>

<style scoped>

</style>
